import Icon from '../components/Icon.vue'

Icon.register({
  bong: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M302.5 512h-221c-23.2 0-44.4-12.6-56-32.7-16.2-28.1-25.5-60.6-25.5-95.3 0-71 38.7-132.9 96-166.1v-153.9l-16 0c-8.9 0-16-7.2-16-16l0-31.7c0-8.8 7.2-16 16-16l223.9-0.3c8.9 0 16 7.2 16 16l0 31.7c0 8.8-7.2 16-16 16l-16 0v154.2c14.1 8.2 27.1 18.1 38.7 29.5l39.4-39.4-9.4-9.4c-6.3-6.3-6.3-16.4 0-22.6l11.3-11.3c6.3-6.3 16.4-6.3 22.6 0l52.7 52.7c6.3 6.3 6.3 16.4 0 22.6l-11.3 11.3c-6.3 6.3-16.4 6.3-22.6 0l-9.4-9.4-43.4 43.4c17.4 28.8 27.4 62.5 27.4 98.6 0 34.8-9.3 67.3-25.5 95.3-11.6 20.1-32.8 32.7-56 32.7zM120.1 259.4c-24.8 14.4-44.1 35.7-56.6 60.6h257c-12.4-24.8-31.8-46.2-56.6-60.6l-23.9-13.9v-181.8l-96 0.1v181.6z'
      }
    ]
  }
})
